const defaults = {
  textPropertyName: '',
  mimeType: 'application/json',
  fileName: 'output.json',
  encoding: 'utf-8',
  addBom: false,
  binaryPropertyName: 'data',
};

export default defaults;
